function captureOpenState (container) {
  if (!container) return { options: [] }

  return {
    options: Array.from(
      container.querySelectorAll('[data-flt-option][data-flt-open]')
    )
      .map(el => el.dataset.fltOptionKey)
      .filter(Boolean)
  }
}

function restoreOpenState (container, state) {
  if (!container || !state) return

  state.options.forEach(key => {
    const option = container.querySelector(
      `[data-flt-option][data-flt-option-key="${key}"]`
    )
    if (!option) return

    option.setAttribute('data-flt-open', '')
    option
      .querySelector('[data-flt-option-toggle]')
      ?.setAttribute('aria-expanded', 'true')
  })
}

const FacetInteractionsMixin = {
  onFacetClick (event) {
    const link = event.target.closest('[data-flt-filter-link]')
    if (link) {
      event.preventDefault()

      if (this.grid) {
        this.grid.renderPage(link.href)
      } else {
        window.location.href = link.href
      }
      return
    }

    const loadMoreLink = event.target.closest('[data-flt-load-more]')
    if (loadMoreLink) {
      event.preventDefault()

      if (this.grid) {
        this.grid.loadMore(loadMoreLink.href)
      } else {
        window.location.href = loadMoreLink.href
      }
      return
    }

    const optionToggle = event.target.closest('[data-flt-option-toggle]')
    if (optionToggle) {
      const option = optionToggle.closest('[data-flt-option]')
      const isOpen = option.hasAttribute('data-flt-open')

      option.toggleAttribute('data-flt-open', !isOpen)
      optionToggle.setAttribute('aria-expanded', String(!isOpen))
      return
    }

    const sortToggle = event.target.closest('[data-flt-sort-toggle]')
    if (sortToggle) {
      const sort = sortToggle.closest('[data-flt-sort]')
      const isOpen = sort.hasAttribute('data-flt-open')

      sort.toggleAttribute('data-flt-open', !isOpen)
      sortToggle.setAttribute('aria-expanded', String(!isOpen))
    }
  },

  onFacetInput (event) {
    const sliderInput = event.target.closest('[data-flt-price-slider-input]')
    if (sliderInput) {
      this.syncPriceFromSlider(sliderInput)
      return
    }

    const priceInput = event.target.closest('[data-flt-price-input]')
    if (priceInput) {
      this.syncPriceFromInput()
    }
  },

  onFacetSubmit (event) {
    if (!event.target.matches('[data-flt-price-form]')) return

    event.preventDefault()
    this.applyPriceForm(event.target)
  },

  syncPriceFromSlider (sliderInput) {
    const minSlider = this.els.priceSliderMin?.element
    const maxSlider = this.els.priceSliderMax?.element
    if (!minSlider || !maxSlider) return

    if (
      sliderInput === minSlider &&
      Number(minSlider.value) > Number(maxSlider.value)
    ) {
      minSlider.value = maxSlider.value
    }
    if (
      sliderInput === maxSlider &&
      Number(maxSlider.value) < Number(minSlider.value)
    ) {
      maxSlider.value = minSlider.value
    }

    const minInput = this.els.priceInputMin?.element
    const maxInput = this.els.priceInputMax?.element

    if (minInput) minInput.value = minSlider.value
    if (maxInput) maxInput.value = maxSlider.value

    this.updatePriceSliderVisual()
  },

  syncPriceFromInput () {
    const minInput = this.els.priceInputMin?.element
    const maxInput = this.els.priceInputMax?.element
    const minSlider = this.els.priceSliderMin?.element
    const maxSlider = this.els.priceSliderMax?.element

    if (minSlider && minInput) minSlider.value = minInput.value || minSlider.min
    if (maxSlider && maxInput) maxSlider.value = maxInput.value || maxSlider.max

    this.updatePriceSliderVisual()
  },

  updatePriceSliderVisual () {
    const minSlider = this.els.priceSliderMin?.element
    const maxSlider = this.els.priceSliderMax?.element
    const rangeBar = this.els.priceRangeBar?.element
    if (!minSlider || !maxSlider || !rangeBar) return

    const max = Number(minSlider.max)
    if (!max) return

    const minPercent = (Number(minSlider.value) / max) * 100
    const maxPercent = (Number(maxSlider.value) / max) * 100

    rangeBar.style.left = `${minPercent}%`
    rangeBar.style.right = `${100 - maxPercent}%`

    minSlider.classList.toggle('flt-PriceSlider_Input-top', minPercent > 50)
  },

  applyPriceForm (form) {
    const formData = new FormData(form)
    const url = new URL(window.location.href)

    formData.forEach((value, key) => {
      if (value) {
        url.searchParams.set(key, value)
      } else {
        url.searchParams.delete(key)
      }
    })

    if (this.grid) {
      this.grid.renderPage(url.toString())
    } else {
      window.location.href = url.toString()
    }
  },

  setupFacetListeners () {
    this.listeners.add(this, 'click', this.onFacetClick.bind(this))
    this.listeners.add(this, 'input', this.onFacetInput.bind(this))
    this.listeners.add(this, 'submit', this.onFacetSubmit.bind(this))
  }
}

if (!customElements.get('facet-filters-form')) {
  class FacetFiltersForm extends window.BAO.CustomElement {
    CLASSES = {
      loading: 'flt-loading'
    }

    constructor () {
      super()

      this.sectionId = this.dataset.sectionId

      this.regionId = `FacetFiltersRegion-${this.sectionId}`
      this.mobileFacetsId = `MobileFacets-${this.sectionId}`
      this.gridId = `ProductGridItems-${this.sectionId}`
      this.loadMoreId = `LoadMore-${this.sectionId}`
    }

    setupListeners () {
      super.setupListeners()

      this.setupFacetListeners()
    }

    get grid () {
      return this
    }

    get region () {
      return document.getElementById(this.regionId)
    }

    get drawerBody () {
      return this.externalEls.drawerBody?.element
    }

    renderPage (url, updateHistory = true) {
      this.classList.add(this.CLASSES.loading)

      const fetchUrl = new URL(url, window.location.origin)
      fetchUrl.searchParams.set('section_id', this.sectionId)

      const currentRegion = this.region
      const drawerBody = this.drawerBody

      const regionOpenState = captureOpenState(currentRegion)
      const drawerOpenState = captureOpenState(drawerBody)
      const hadOpenState =
        regionOpenState.options.length > 0 || drawerOpenState.options.length > 0

      fetch(fetchUrl.toString())
        .then(response => response.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html')
          const newRegion = doc.getElementById(this.regionId)

          if (newRegion && currentRegion) {
            currentRegion.innerHTML = newRegion.innerHTML
            restoreOpenState(currentRegion, regionOpenState)
            this.els = this.getElements(this._getElementIdentifiers())
          }

          const newMobileFacets = doc.getElementById(this.mobileFacetsId)

          if (newMobileFacets && drawerBody) {
            drawerBody.innerHTML = newMobileFacets.innerHTML
            restoreOpenState(drawerBody, drawerOpenState)
          }

          const clearAllLink = document.getElementById('MobileFiltersClearAll')

          if (clearAllLink) {
            const hasActiveFilters = Array.from(
              fetchUrl.searchParams.keys()
            ).some(key => key.startsWith('filter.'))

            clearAllLink.hidden = !hasActiveFilters
          }

          if (updateHistory) {
            const historyUrl = new URL(url, window.location.origin)
            historyUrl.searchParams.delete('section_id')
            window.history.pushState({}, '', historyUrl.toString())
          }

          this.classList.remove(this.CLASSES.loading)

          if (!hadOpenState) {
            currentRegion?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }

          window.dispatchEvent(new CustomEvent('facet-filters:updated'))
        })
        .catch(() => {
          window.location.href = url
        })
    }

    loadMore (url) {
      const loadMoreRegion = document.getElementById(this.loadMoreId)
      const grid = document.getElementById(this.gridId)

      loadMoreRegion?.classList.add(this.CLASSES.loading)

      const fetchUrl = new URL(url, window.location.origin)
      fetchUrl.searchParams.set('section_id', this.sectionId)

      fetch(fetchUrl.toString())
        .then(response => response.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html')
          const newGrid = doc.getElementById(this.gridId)

          if (newGrid && grid) {
            grid.append(...newGrid.childNodes)
          }

          const newLoadMoreRegion = doc.getElementById(this.loadMoreId)

          if (newLoadMoreRegion && loadMoreRegion) {
            loadMoreRegion.innerHTML = newLoadMoreRegion.innerHTML
          }

          loadMoreRegion?.classList.remove(this.CLASSES.loading)
        })
        .catch(() => {
          window.location.href = url
        })
    }
  }

  Object.assign(FacetFiltersForm.prototype, FacetInteractionsMixin)
  customElements.define('facet-filters-form', FacetFiltersForm)
}

if (!customElements.get('filter-drawer-body')) {
  class FilterDrawerBody extends window.BAO.CustomElement {
    constructor () {
      super()

      this.resyncEls = this.resyncEls.bind(this)
    }

    setupListeners () {
      super.setupListeners()

      this.setupFacetListeners()
      this.listeners.add(window, 'facet-filters:updated', this.resyncEls)
    }

    get grid () {
      return this.externalEls.facetFiltersForm?.element
    }

    resyncEls () {
      this.els = this.getElements(this._getElementIdentifiers())
    }
  }

  Object.assign(FilterDrawerBody.prototype, FacetInteractionsMixin)
  customElements.define('filter-drawer-body', FilterDrawerBody)
}

document.addEventListener('click', event => {
  if (!event.target.closest('[data-flt-sort]')) {
    document
      .querySelectorAll('[data-flt-sort][data-flt-open]')
      .forEach(openSort => {
        openSort.removeAttribute('data-flt-open')
        openSort
          .querySelector('[data-flt-sort-toggle]')
          ?.setAttribute('aria-expanded', 'false')
      })
  }

  if (!event.target.closest('[data-flt-option]')) {
    document
      .querySelectorAll('[data-flt-option][data-flt-open]')
      .forEach(openOption => {
        openOption.removeAttribute('data-flt-open')
        openOption
          .querySelector('[data-flt-option-toggle]')
          ?.setAttribute('aria-expanded', 'false')
      })
  }
})

window.addEventListener('popstate', () => {
  document
    .querySelector('facet-filters-form')
    ?.renderPage(window.location.href, false)
})
